import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// Spaces to ensure I don't organize by name and break the chain

import 'primereact/resources/themes/lara-light-indigo/theme.css';

import 'primeflex/primeflex.min.css';

import 'primeicons/primeicons.css';

import 'primereact/resources/primereact.min.css';

import './index.css';

import RequireAdmin from './component/require-admin';
import RequireAuth from './component/require-auth';
import ProvideEmployee from './context/employee';
import ProvideSite from './context/site';
import ProvideSocket from './context/socket';
import EmployeePage from './page/employee';
import EmployeesPage from './page/employees';
import ErrorPage from './page/error';
import IndexPage from './page/index';
import ListsPage from './page/lists';
import ParentPage from './page/parent';
import ParentsPage from './page/parents';
import ProgramPage from './page/program';
import ProgramsPage from './page/programs';
import ReportsPage from './page/reports';
import Root from './page/root';
import ServicesGroupPage from './page/services-group';
import ServicesIndividualPage from './page/services-individual';
import ServicesProgramPage from './page/services-program';
import SignInPage from './page/sign-in';
import ValidateTokenPage from './page/validate-token';

function InitApp() {
    return (
        <ProvideSocket>
            <ProvideEmployee>
                <ProvideSite>
                    <RouterProvider router={router} />
                </ProvideSite>
            </ProvideEmployee>
        </ProvideSocket>
    );
}

const router = createBrowserRouter([
    {
        path: '/',
        element: <Root />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: (
                    <RequireAuth>
                        <IndexPage />
                    </RequireAuth>
                )
            },
            { path: 'sign-in', element: <SignInPage /> },
            { path: 'validate-token', element: <ValidateTokenPage /> },
            {
                path: 'employees',
                element: (
                    <RequireAuth>
                        <RequireAdmin>
                            <EmployeesPage />
                        </RequireAdmin>
                    </RequireAuth>
                )
            },
            {
                path: 'employee/:id',
                element: (
                    <RequireAuth>
                        <EmployeePage />
                    </RequireAuth>
                )
            },
            {
                path: 'lists',
                element: (
                    <RequireAuth>
                        <RequireAdmin>
                            <ListsPage />
                        </RequireAdmin>
                    </RequireAuth>
                )
            },
            {
                path: 'reports',
                element: (
                    <RequireAuth>
                        <RequireAdmin>
                            <ReportsPage />
                        </RequireAdmin>
                    </RequireAuth>
                )
            },
            {
                path: 'parents',
                element: (
                    <RequireAuth>
                        <ParentsPage />
                    </RequireAuth>
                )
            },
            {
                path: 'parent/:id',
                element: (
                    <RequireAuth>
                        <ParentPage />
                    </RequireAuth>
                )
            },
            {
                path: 'programs',
                element: (
                    <RequireAuth>
                        <ProgramsPage />
                    </RequireAuth>
                )
            },
            {
                path: 'program/:id',
                element: (
                    <RequireAuth>
                        <ProgramPage />
                    </RequireAuth>
                )
            },
            {
                path: 'services-individual',
                element: (
                    <RequireAuth>
                        <ServicesIndividualPage />
                    </RequireAuth>
                )
            },
            {
                path: 'services-group',
                element: (
                    <RequireAuth>
                        <ServicesGroupPage />
                    </RequireAuth>
                )
            },
            {
                path: 'services-program',
                element: (
                    <RequireAuth>
                        <ServicesProgramPage />
                    </RequireAuth>
                )
            }
        ]
    }
]);

const root = createRoot(document.getElementById('root'));

root.render(<InitApp />);
